import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';

const PaymentCardToggle = ({ dataQa, linkAction, linkText, preLinkText }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <p className="card-toggle">
        {preLinkText}
        <button
          className="card-toggle__button-link"
          data-qa={dataQa}
          onClick={linkAction}
          type="button"
        >
          {linkText}
        </button>
      </p>
      <style jsx>{`
        .card-toggle {
          font-size: 14px;
          font-style: italic;
          font-weight: normal;
          text-align: right;
          margin-bottom: 0;
        }
        .card-toggle__button-link {
          background: transparent;
          border: 0;
          color: ${theme.colors.primary};
          font-style: italic;
          margin: 0;
          padding: 0;
        }
        .card-toggle__button-link:hover {
          color: ${theme.colors.checkoutlinkhover};
          text-decoration: underline;
        }
      `}</style>
    </>
  );
};

export default PaymentCardToggle;

PaymentCardToggle.propTypes = {
  dataQa: PropTypes.string,
  linkAction: PropTypes.func.isRequired,
  linkText: PropTypes.string.isRequired,
  preLinkText: PropTypes.string.isRequired,
};
